import React, {Component} from 'react';
import PropTypes from 'prop-types'
import {Collapse} from "reactstrap"

class AffiliateStatisticCollapse extends Component {
    render() {
        const {isOpen} = this.props;
        const {clicks, conversions, earned, paid, pending} = this.props.affiliateStatisticData
        return (
            <div className='AffiliateStatisticCollapse col-12'>
                <Collapse isOpen={isOpen}>
                    <div className='statistic-table'>
                        <div className='row table-row'>
                            <div className='col-2'>
                                Clicks
                            </div>
                            <div className='col-3'>
                                Conversions
                            </div>
                            <div className='col-3'>
                                Pending
                            </div>
                            <div className='col-2'>
                                Earned
                            </div>
                            <div className='col-2'>
                                Paid
                            </div>

                        </div>
                        <div className='row table-row'>
                            <div className='col-2'>
                                {clicks}
                            </div>
                            <div className='col-3'>
                                {conversions}
                            </div>
                            <div className='col-3'>
                                {`$${pending}`}
                            </div>
                            <div className='col-2'>
                                {`$${earned}`}
                            </div>
                            <div className='col-2'>
                                {`$${paid}`}
                            </div>

                        </div>
                    </div>
                </Collapse>
            </div>

        )
    }
}

AffiliateStatisticCollapse.defaultProps = {
    affiliateStatisticData: {
        clicks: 0,
        conversions: 0,
        earned: 0,
        paid: 0,
        pending: 0,
    }
}


AffiliateStatisticCollapse.propTypes = {
    affiliateStatisticData: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    toggleCollapse: PropTypes.func.isRequired,

}


export default AffiliateStatisticCollapse;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/users/AffiliateStatisticCollapse.js